import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import { Card } from "shared/components/Card";
import WarningFillIcon from "shared/icons/warningFillIcon.svg?react";
import { getDisclosureI18nReplace } from "../../../../../../../utils/sumissionDisclosureVerification";
import { Button, ButtonVariant } from "shared/components";
import { Partner } from "types/landlord/partner";

type ReviewAndSendEmailStepProps = {
  description: string;
  partnerNameInSubmissionDisclosure: string;
  partner?: Partner;
  onSendEmail: () => void;
  isLoading: boolean;
};

export const ReviewAndSendEmailStep = ({
  description,
  partnerNameInSubmissionDisclosure,
  partner,
  onSendEmail,
  isLoading
}: ReviewAndSendEmailStepProps) => {
  return (
    <>
      <div className="w-full h-full flex flex-col items-center gap-6 p-6 overflow-y-auto">
        <div className="space-y-1 max-w-[500px]">
          <p className="font-bold text-xl">
            Disclosure will be sent to the applicant for signature
          </p>
          <p className="text-content-400 text-sm">
            Reports will not run until the applicant signs the disclosure
          </p>
        </div>
        <Card className="max-w-[500px]">
          <div className="markdown-prose break-anywhere marker:text-content-400 prose-p:text-sm prose-a:text-content-400 p-4">
            <div className="mt-6 flex gap-2 items-center">
              <WarningFillIcon className="w-5 h-5 text-danger-500 shrink-0" />
              <h6 className="!text-sm font-bold text-danger-600">
                By submitting my application, I hereby warrant that all
                statements set forth in this application are true.
              </h6>
            </div>
            <ReactMarkdown rehypePlugins={[rehypeRaw]}>
              {description
                .replace(
                  "{@t verifications.submission-disclosure.steps.submission-disclosure.description @t}",
                  getDisclosureI18nReplace(partner)
                )
                .replaceAll(
                  "{{partner_name}}",
                  partnerNameInSubmissionDisclosure
                )
                .replaceAll(
                  "#{consumer_finance_file}",
                  "https://files.consumerfinance.gov/f/201504_cfpb_summary_your-rights-under-fcra.pdf"
                )}
            </ReactMarkdown>
          </div>
        </Card>
      </div>
      <div className="h-20 border-t border-alpha-100 bg-white gap-2 flex justify-end items-center pr-4">
        <Button
          tooltipZIndex={51}
          variant={ButtonVariant.PRIMARY}
          className="w-[125px]"
          onClick={onSendEmail}
          loading={isLoading}
        >
          Send email
        </Button>
      </div>
    </>
  );
};
